module.exports = __webpack_public_path__ + "cfbfe2d48cab4b385bf5cb1ed9bb03bb.gif";


//////////////////
// WEBPACK FOOTER
// ./public/img/movie-icons/02_icon_project_corporate.gif
// module id = 687
// module chunks = 0